// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2RPrp","checkboxCol":"Table_checkboxCol__2NU3h","emailCol":"Table_emailCol__3sm9Q","actionCol":"Table_actionCol__1BgnJ"};